import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  deleteSeasonRateRuleAsync,
  getSeasonRatePreparationRestrictionRuleAsync,
  selectPreparationRestrictionRuleDetails,
  selectPreparationRestrictionRuleDetailsLoadingStatus,
  updateSeasonRatePreparationRestrictionRuleAsync,
} from '../seasonRateRulesSlice';
import PreparationRestrictionForm from './PreparationRestrictionForm';
import { PreparationRestrictionRuleDetails } from '../../../common/types/rates.types';

function SeasonRatePreparationRestriction({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const preprationRestrictionRuleDetails = useAppSelector(
    selectPreparationRestrictionRuleDetails,
  );
  const preparationRestrictionStatus = useAppSelector(
    selectPreparationRestrictionRuleDetailsLoadingStatus,
  );

  const initialData: PreparationRestrictionRuleDetails = {
    seasonRateId,
    preparationDays: null,
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRatePreparationRestrictionRuleAsync(seasonRateId));
  }, [seasonRateId, dispatch]);

  useEffect(() => {
    if (
      preprationRestrictionRuleDetails &&
      preprationRestrictionRuleDetails.seasonRateId === seasonRateId
    ) {
      setData(preprationRestrictionRuleDetails);
    } else {
      setData(initialData);
    }
  }, [preprationRestrictionRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const onSubmit = () => {
    dispatch(updateSeasonRatePreparationRestrictionRuleAsync(data));
    setSubmitted(true);
  };

  const onDelete = () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      dispatch(deleteSeasonRateRuleAsync(data.id));
      setSubmitted(false);
      setData(initialData);
      setDeleted(true);
    }
  };

  return (
    <PreparationRestrictionForm
      loadingStatus={preparationRestrictionStatus}
      handleInputChange={handleInputChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRatePreparationRestriction;
